import { useTranslation } from 'react-i18next';
import { getAttr } from '../../../../../../../features/helpers/apiHelpers';
import {
  INVITATIONSOURCETYPE_CSV,
  INVITATIONSOURCETYPE_EXCEL,
} from '../../../../../../../constants/api';

export function useTexts(invitationSource, fileExtension) {
  const { t: translator } = useTranslation();
  const invitationSourceType = getAttr(
    invitationSource,
    'invitationSourceType',
  );

  const cprColumnHeader = getAttr(invitationSource, 'cprColumnHeader');
  const cvrColumnHeader = getAttr(invitationSource, 'cvrColumnHeader');
  const emailColumnHeader = getAttr(invitationSource, 'emailColumnHeader');

  const texts = {
    headerText: translator('pages.createHearing.uploadInvitees'),
    closeButtonAriaLabel: translator('ariaLabel.panelClose'),
    chooseFile: translator('pages.createHearing.uploadInviteesChooseFile'),
    description: '',
    callout: '',
    exampleFile: translator('pages.createHearing.exampleFile'),
    note: translator('pages.createHearing.uploadInviteesNote'),
    uploadError: translator('components.fileComponents.uploadFileError'),
    cancel: translator('global.cancel'),
    confirm: translator('global.confirm'),
  };

  if (invitationSourceType === INVITATIONSOURCETYPE_CSV) {
    texts.description = translator(
      'pages.createHearing.uploadInviteesDescriptionCsv',
      {
        fileExtension: `.${fileExtension}`,
        cprColumnHeader,
        cvrColumnHeader,
        emailColumnHeader,
      },
    );
    texts.callout = translator('pages.createHearing.uploadInviteesCallout');
  } else if (invitationSourceType === INVITATIONSOURCETYPE_EXCEL) {
    texts.description = translator(
      'pages.createHearing.uploadInviteesDescriptionExcel',
      {
        fileExtension: `.${fileExtension}`,
        cprColumnHeader,
        cvrColumnHeader,
        emailColumnHeader,
      },
    );
  }

  return { ...texts };
}
